import React from "react"
import FooterLinkCentering from "molecules/FooterLinkCentering"

const Footer = () => {
  return <FooterLinkCentering />
}

export default Footer
